import Vue from 'vue';
import VueRouter from 'vue-router';
import { mainMiddleware } from '@/utils/router/';

// separeted files
import SuppliersRoutes from '@/router/supplier';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: () => import('@/views/new-home'),
        meta: { requireAuth: false }, // validação de autenticação
    },
    {
        path: '/contratante',
        component: () => import('@/layouts/default.vue'),
        meta: { requireAuth: false }, // validação de autenticação
        children: [
            { path: '/404', component: () => import('@/views/not-found'), name: 'http404' },
            {
                path: '',
                name: 'LandingPage',
                meta: { backgroundGrey: true, header: 'guest-contractor' },
                component: () => import('@/views/landing-page/LandingPage.vue')
            },
            {
                path: '/nova-cotacao',
                name: 'StructuredQuote',
                meta: { backgroundGrey: true, header: 'blank' },
                component: () => import('@/views/contractor/structured-quote/StructuredQuote')
            },
            {
                path: '/planos',
                name: 'Plans',
                // Saber como ter planos aqui :ENGELINK
                component: () => import('@/views/supplier/plans/Plans.vue')
            },
            {
                path: '/painel-de-concorrencias',
                name: 'CompetitionDashboardGuest',
                meta: { backgroundGrey: true, isSupplier: true },
                component: () => import('@/views/supplier/competition-dashboard/CompetitionDashboard.vue')
            },
            {
                path: '/cadastro',
                name: 'Signup',
                meta: { backgroundGrey: true, header: 'guest-contractor' },
                component: () => import('@/views/signup/index-form/IndexForm.vue')
            },
            {
                path: '/cadastro/formulario',
                name: 'SignupForm',
                meta: { backgroundGrey: true, header: 'blank' },
                component: () => import('@/views/signup/form/Form.vue')
            },
            {
                path: '/cadastro/complemento',
                name: 'SupplierComplement',
                meta: { backgroundGrey: true, header: 'blank' },
                component: () => import('@/views/signup/Complement.vue')
            },
            {
                path: '/especialista-complemento',
                name: 'complementSpecialist',
                meta: { backgroundGrey: true, complement: 'specialist' },
                component: () => import('@/views/signup/Complement.vue')
            },
            {
                path: '/fale-conosco-complemento',
                name: 'contactUsAddOn',
                meta: { backgroundGrey: true, complement: 'contactUs' },
                component: () => import('@/views/signup/Complement.vue')
            },
            {
                path: '/solicitacao/:partner',
                name: 'LadingPageCondo',
                component: () => import('@/views/condo-administrator/landing-page/LandingPage.vue')
            },
            {
                path: '/fale-conosco',
                name: 'ContactUs',
                meta: { backgroundGrey: true },
                component: () => import('@/views/contact-us')
            },
            {
                path: '/termos-de-uso-cookies',
                name: 'pageTermsOfUseCookies',
                meta: { backgroundGrey: true },
                component: () => import('@/views/page-terms-of-use')
            },
            {
                path: '/politica-de-privacidade',
                name: 'pageTermsOfUsePrivacy',
                meta: { backgroundGrey: true },
                component: () => import('@/views/page-terms-of-use')
            },
            {
                path: '/termos-de-uso',
                name: 'pageTermsOfUse',
                meta: { backgroundGrey: true },
                component: () => import('@/views/page-terms-of-use')
            },
            {
                path: 'recuperar-senha',
                name: 'RecoverPassword',
                meta: { backgroundGrey: true },
                component: () => import('@/views/recover-password')
            },
            {
                path: '/senha/alterar',
                name: 'ChangePassword',
                meta: { backgroundGrey: true },
                component: () => import('@/views/change-password')
            },
            {
                path: '/condotechs',
                name: 'CondoTechsLandingpage',
                meta: { backgroundGrey: true, header: 'condotechs' },
                component: () => import('@/views/condotechs/landing-page/')
            },
            {
                path: '/condotechs/contato/:id',
                name: 'CondoTechsContactUs',
                meta: { backgroundGrey: true, header: 'condotechs' },
                component: () => import('@/views/condotechs/contact-us')
            },
            {
                path: '/condotechs/detalhes/:id',
                name: 'CondoTechsDetails',
                meta: { backgroundGrey: true, header: 'condotechs' },
                component: () => import('@/views/condotechs/details')
            },
            {
                path: '/condotechs-enterprise',
                name: 'CondoTechsEnterpriseLandingpage',
                meta: { backgroundGrey: true, header: 'none', hiddenFooter: true },
                component: () => import('@/views/condotechs/landing-page/')
            },
            {
                path: '/condotechs-enterprise/contato/:id',
                name: 'CondoTechsEnterpriseContactUs',
                meta: { backgroundGrey: true, header: 'none', hiddenFooter: true },
                component: () => import('@/views/condotechs/contact-us')
            },
            {
                path: '/condotechs-enterprise/detalhes/:id',
                name: 'CondoTechsEnterpriseDetails',
                meta: { backgroundGrey: true, header: 'none', hiddenFooter: true },
                component: () => import('@/views/condotechs/details')
            },
            {
                path: '/unsubscribe',
                name: 'Unsubscribe',
                meta: { backgroundGrey: true },
                component: () => import('@/views/unsubscribe')
            },
            {
                path: '/rede-de-contatos',
                name: 'GuestContactNetwork',
                meta: { backgroundGrey: false, isSupplier: true },
                component: () => import('@/views/supplier/contact-network')
            },
            {
                path: '/rede-de-perfis',
                name: 'NetworkSuppliers',
                meta: { backgroundGrey: true, isSupplier: false, header: 'guest-contractor' },
                component: () => import('@/views/supplier/network-suppliers')
            },
            {
                path: 'adiar-cotacao/:quotationId',
                name: 'PostponeQuotation',
                component: () => import('@/views/postpone-quotation/')
            },
            {
                path: 'rede-de-perfis/fornecedor/:id',
                name: 'ProfileNetworkSupplier',
                meta: { backgroundGrey: true, header: 'guest-contractor' },
                component: () => import('@/views/profile-network/supplier-details/')
            }
        ]
    },
    {
        path: '/oferta',
        component: () => import('@/layouts/default.vue'),
        meta: { requireAuth: false }, // validação de autenticação
        children: [
            {
                path: ':id',
                name: 'OffersDetailsGuestNoTag',
                redirect: to => ({
                    name: 'OffersDetailsGuest',
                    params: { tag: 'outra', id: to.params.id }
                }),
                meta: { requireAuth: false }, // validação de autenticação
            },
            {
                path: ':tag/:id',
                name: 'OffersDetailsGuest',
                meta: { backgroundGrey: true, isSupplier: true, requireAuth: false },
                component: () => import('@/views/supplier/offer-details')
            },
        ]
    },
    {
        path: '/cancelar-inscricao',
        name: 'UnsubscribeMarketing',
        meta: { backgroundGrey: true },
        component: () => import('@/views/unsubscribe-marketing')
    },
    {
        path: '/',
        component: () => import('@/layouts/default.vue'),
        meta: { requireAuth: true }, // validação de autenticação
        children: [
            {
                path: '/fornecedor',
                component: () => import('@/views/supplier/'),
                children: [...SuppliersRoutes]
            },
            {
                path: '/cotacoes',
                name: 'ListCompetitions',
                meta: { backgroundGrey: true, isContractor: true },
                component: () => import('@/views/contractor/competitions/list/List.vue')
            },
            {
                path: '/cotacao/:id/revisao',
                name: 'CompetitionRequester',
                meta: { backgroundGrey: true, isContractor: true },
                component: () => import('@/views/contractor/competitions/new/New.vue')
            },
            {
                path: '/cotacao/:id/propostas',
                name: 'CompetitionProposals',
                meta: { backgroundGrey: true, isContractor: true },
                component: () => import('@/views/contractor/competitions/proposals/Proposals.vue')
            },
            {
                path: '/cotacao/:id/:type',
                name: 'CompetitionEditionDetails',
                meta: { backgroundGrey: true, isContractor: true },
                component: () => import('@/views/contractor/quotation/Quotation.vue')
            },
            {
                path: '/vencedor-cotacao/:id',
                name: 'QuotationsWinnersDetails',
                meta: { backgroundGrey: true, isContractor: true },
                component: () => import('@/views/contractor/quotations-winners/QuotationsWinners.vue')
            },
            {
                path: '/vencedor-cotacao',
                name: 'QuotationsWinners',
                meta: { backgroundGrey: true, isContractor: true },
                component: () => import('@/views/contractor/quotations-winners/QuotationsWinners.vue')
            },
            {
                path: '/inicio',
                name: 'Home',
                meta: { header: 'blank' },
                component: () => import('@/views/home/Home.vue')
            },
            {
                path: '/nova-cotacao',
                name: 'NewCompetition',
                meta: { backgroundGrey: true, isContractor: true },
                component: () => import('@/views/contractor/competitions/new/New.vue')
            },
            {
                path: '/editar-perfil',
                name: 'EditProfile',
                meta: { backgroundGrey: true, isContractor: true },
                component: () => import('@/views/signup/form/Form.vue')
            },
            {
                path: '/fornecedor/contatos',
                name: 'MyContacts',
                meta: { backgroundGrey: true, isSupplier: true },
                component: () => import('@/views/supplier/list-contacts')
            },
            {
                path: '/fornecedor/minhas-cotacoes',
                name: 'MyOpportunities',
                meta: { backgroundGrey: true, isSupplier: true },
                component: () => import('@/views/supplier/opportunities')
            },
            {
                path: '/fornecedor/checkout',
                name: 'Checkout',
                meta: { backgroundGrey: true, header: 'blank' },
                component: () => import('@/views/checkout')
            },
            {
                path: '/fornecedor/new-checkout',
                name: 'New Checkout',
                meta: { backgroundGrey: true, isSupplier: true },
                component: () => import('@/views/new-checkout')
            },
            {
                path: '/fornecedor/rede-de-contatos',
                name: 'ContactNetwork',
                meta: { backgroundGrey: true, isSupplier: true },
                component: () => import('@/views/supplier/contact-network')
            },
            {
                path: '/fornecedor/engelink-marketing/:id',
                name: 'ReservedForYou',
                meta: { backgroundGrey: true, isSupplier: true },
                component: () => import('@/views/supplier/offer-details')
            },
            {
                path: '/fornecedor/engelink-enterprise/:id',
                name: 'Enterprise',
                meta: { backgroundGrey: true, isSupplier: true },
                component: () => import('@/views/supplier/enterprise')
            },
            {
                path: '/confirmar-ocupacao/:id/:accept',
                name: 'ConfirmOccupation',
                meta: { backgroundGrey: true, isSupplier: true },
                component: () => import('@/views/confirm-occupation')
            }
        ]
    },
    {
        path: '/credito',
        name: 'EngelinkCredito',
        component: () => import('@/views/credito')
    },
    {
        path: '/entrar',
        component: () => import('@/layouts/default.vue'),
        children: [
            {
                path: '/',
                name: 'Login',
                meta: { backgroundGrey: true, header: 'guest-contractor' },
                component: () => import('@/views/login/Login.vue')
            }
        ]
    },
    {
        path: '/magic-link-redirect',
        name: 'MagicLink',
        component: () => import('@/views/magic-link/MagicLink.vue')
    },
    { path: '**', redirect: { name: 'http404' } }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    }
});

// Middleware
router.beforeEach(async (to, from, next) => {
    mainMiddleware(to, from, next);
});

export default router;
